import * as React from 'react';
const SvgApproval = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.78.72a.75.75 0 0 0-1.06 1.06L9.94 3H9.5a7.5 7.5 0 1 0 7.5 7.5.75.75 0 0 0-1.5 0 6 6 0 1 1-6.061-6l-.72.72A.75.75 0 0 0 9.78 6.28l2.25-2.25a.75.75 0 0 0 0-1.06zm3.74 6.24a.75.75 0 0 1 .02 1.06l-3.85 4a.75.75 0 0 1-1.08 0l-1.65-1.714a.75.75 0 1 1 1.08-1.04l1.11 1.152 3.31-3.438a.75.75 0 0 1 1.06-.02"
    />
  </svg>
);
export default SvgApproval;
